import React, { useEffect, useState } from 'react'
import './report.css'
import { Link } from 'react-router-dom'
import { submitReport, getReports } from '../../api/reportApi'
import { useSelector, useDispatch } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import Loader from '../../components/loader/Loader'
import moment from 'moment'
import { DataGrid } from '@mui/x-data-grid';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { handleAddReport, handleOpenReportModal } from '../../state/reportSlice'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';
import { TiArrowRightOutline } from "react-icons/ti";
import LinearProgress from '@mui/material/LinearProgress';
import ReportInfo from './ReportInfo'
import { userLogin } from '../../state/userSlice'

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);


const ActionCell = ({param}) => {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(handleOpenReportModal(param?.row));
  };

  return (
      <button onClick={handleClick}
      className="report__table-btn">View</button>
  )
}

const columns = [

    {
        field: 'title',
        headerName: 'Title',
        width: 500,
    },
    {
        field: 'date',
        headerName: 'Date',
        width: 200,
        renderCell: (param)=>(
          <span className="report__table-text">
            {moment(param?.row.date).format('DD MMMM YYYY')}
          </span>
        )
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (param) => <ActionCell param={param} />
    },
];


// REPORT FORM
const SubmitReport = ({setToggleReport, handleGetReports})=>{
  const {user} = useSelector((state)=> state.user)
  const [isLoading , setIsLoading ] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const dispatch = useDispatch()

  const {
    register,
    handleSubmit,
    formState:{errors},
    control,
    reset,
  } = useForm({
    mode: 'onChange'
  })


  // HANDLE SUBMIT TASKS FUNCTION
  const handleSubmitReport = async (data)=>{
    setIsLoading(true)
    try {
        const formData = new FormData()
        const {title, description, date } = data
        window.alert(date)
        formData.append('title', title)
        formData.append('date', date)
        formData.append('description', description)
        formData.append('upload', selectedFile)
        const res = await submitReport(user?.token, formData)
        setToggleReport(false)
        if(res?.success){
            MySwal.fire({
                icon: 'success',
                title: res?.message,
                showConfirmButton: false,
                timer: 3000
            });
            const newData = {token: res?.token, ...res?.user}
            dispatch(userLogin(newData))
            handleGetReports()
            reset()
            dispatch(handleAddReport(res?.data))
        }else{
          MySwal.fire({
            icon: 'error',
            title: res?.message,
            showConfirmButton: false,
            timer: 4000
          });
        }
        setIsLoading(false)
    } catch (error) {
        console.log(error)
        setIsLoading(false)
        MySwal.fire({
          icon: 'error',
          title: "There's an error processing your request, Try again",
          showConfirmButton: false,
          timer: 3000
        });
    }
  }

  return (
    <div className='modal' 
    onClick={()=>setToggleReport(false)}>
      <div className="modal-container">
        <div className="modal-content overflow" 
        onClick={(e)=>e.stopPropagation()}>
          {/* TODO FORM */}
          <form className="modal-form" 
          onSubmit={handleSubmit(handleSubmitReport)}
          >
            {/* FORM HEADING */}
            <div className="modal-heading">
              {/* TITLE */}
              <h4 className="modal-title">
                End of the Day Report
              </h4>
              {/* CLOSE BUTTON */}
              <button onClick={()=>setToggleReport(false)}
              className="modal-btn">
                <i class='bx bx-x'></i>
              </button>
            </div>

            {/* TITLE */}
            <div className="modal-field">
              <label htmlFor="title" className="modal-label">Title</label>
              <input name="title" type="text" className="modal-input"
                {...register('title',{required: 'This field is required'})}
              />
              {errors.title && <span className="modal-error">
                {errors.title.message}
              </span>}
            </div>
            
            {/* DESCRIPTION */}
            <div className="modal-field">
              <label htmlFor="description" className="modal-label">
                Report
              </label>
              <Controller
                  name="description"
                  control={control}
                  defaultValue=""
                  rules={{required: 'This field is required'}}
                  render={({ field }) => (
                    <ReactQuill
                      name="description"
                      theme="snow"
                      value={field.value}
                      onChange={(content) => field.onChange(content)}
                      style={{width: '100%',}}
                    />
                  )}
                />
                {errors.description && <span className="modal-error">
                {errors.description.message}
              </span>}
            </div>

            {/* DATE */}
            <div className="modal-field">
              <label htmlFor="date" className="modal-label">
                Date (Optional - You have the option to specify a date if you are submitting yesterday's report.)
              </label>
              <input name="date" type="date" className="modal-input"
                {...register('date')}
              />
              {errors.date && <span className="modal-error">
                {errors.date.message} 
              </span>}
            </div>
            
            {/* ATTACHMENT */}
            <div className="modal-field">
              <label htmlFor="file" className="modal-label">
                Attachment(Optional)
              </label>
              <input onChange={(e)=>setSelectedFile(e.target.files[0])}
              name="upload" type="file" className="modal-input"/>
            </div>

            {/* SUBMIT BUTTON */}
            <div className="modal-field">
              {
                isLoading ? <Loader/> 
                : <button 
                type='submit'
                className="modal-button button">
                  Submit
                </button>
              }
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}


const Report = () => {
  const {user} = useSelector((state)=> state.user)
  const [toggleReport, setToggleReport] = useState(false)
  const {report, reportModal} = useSelector((state)=> state.report)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedMonth, setSelectedMonth] = useState('');
  const dispatch = useDispatch()

  // HANDLE GET TASKS
  const handleGetReports = async ()=>{
    setIsLoading(true)
    try {
      const res = await getReports(user?.token)
      dispatch(handleAddReport(res?.data))
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }
  
  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
  }
  
  const currentDate = new Date()
  const currentYear = currentDate.getFullYear()
  
  const filteredReports = Array.isArray(report) ? report.filter((item) => {
      const createdDate = new Date(item.createdAt);
      const reportMonth = createdDate.getMonth() + 1;
      const reportYear = createdDate.getFullYear();

      return selectedMonth === '' || (reportMonth === parseInt(selectedMonth) && reportYear === currentYear);
  }) : [];

  const options = [];
  for (let month = 1; month <= 12; month++) {
      options.push(<option key={month} 
        value={month}>{new Date(currentYear, month - 1).toLocaleString('default', { month: 'long' })}</option>);
  }

  const sortReportByDate = [...(filteredReports[0]?.reports || [])]?.sort((a, b) => new Date(a?.date) - new Date(b?.date))

  useEffect(()=>{
    handleGetReports()
  },[])

  return (
    <section className='report'>
      {/* HEADING */}
      <div className="heading">
        <div className="heading__box">
          <div className="heading-item">
            <h3 className="heading-title">Daily Report | </h3>
            <i class='bx bx-home heading__title-icon'></i>
            <Link to="/" className="heading-text">
              Home <i class='bx bx-chevron-right heading-icon'></i>
            </Link>
            <span className="heading-text">
              Daily Report <i class='bx bx-chevron-right heading-icon'></i>
            </span>
          </div>
          <p className="heading-text">
            End of the day report
          </p>
        </div>
        <button 
        onClick={()=>setToggleReport(!toggleReport)}
        className="heading__box-btn button">
            Submit Report
        </button>
      </div>

      {isLoading && <LinearProgress/>}

      <div className="report__container">
        {/* CONTAINER HEADING */}
        <div className="report__heading">
          <h4 className="report__heading-title">
            Total for {moment().format('MMMM YYYY')}:
            <TiArrowRightOutline size={18}/> 
            <span>{filteredReports[0]?.reports?.length}</span>
          </h4>
          <div className="report__search">
            <span className="report__search-title">
              Search by months
            </span>
            <select value={selectedMonth} onChange={handleMonthChange}
            className="report__search-input">
              <option value="" disabled>All Month</option>
              {options}
            </select>
          </div>
        </div>

        {/* REPORT TABLE */}
        <div className="report__table">
          <DataGrid
            getRowId={(row => row._id)}
            rows={sortReportByDate ?? []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
            getRowHeight={() => 'auto'} 
            sx={{
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
                py: 0.5,
            },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
                py: '5px',
            },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
                py: '10px',
            },
            }}
            experimentalFeatures={{ lazyLoading: true }}
          />
        </div>
      </div>

      {toggleReport && <SubmitReport 
      handleGetReports={handleGetReports}
      setToggleReport={setToggleReport}/>}
      {reportModal.isOpen && <ReportInfo report={reportModal.data}/>}
    </section>
  )
}

export default Report